import { render } from "./VerseNavBar.vue?vue&type=template&id=43e9a423&ts=true"
import script from "./VerseNavBar.vue?vue&type=script&lang=ts"
export * from "./VerseNavBar.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__